import { render } from "./UpdateInvestorModel.vue?vue&type=template&id=648d4dc4&scoped=true"
import script from "./UpdateInvestorModel.js?vue&type=script&lang=js"
export * from "./UpdateInvestorModel.js?vue&type=script&lang=js"

import "./UpdateInvestorModel.vue?vue&type=style&index=0&id=648d4dc4&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648d4dc4"]])

export default __exports__